module.exports = __webpack_public_path__ + "img/w10.50070221.png";